import React, { useState } from 'react';
import { CheckCircle2, ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
interface Tomo {
  icon: string;
  title: string;
  subtitle: string;
  situation: string;
  features: string[];
  result: string;
}
export function ProductShowcase() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const tomos: Tomo[] = [{
    icon: '📘',
    title: 'TOMO 1 — Mentalidad y Psicología del Dinero',
    subtitle: '¿Qué piensa tu alumno sobre el dinero?',
    situation: 'El primer contacto con las finanzas puede ser el más transformador o el más aburrido. Este tomo convierte el dinero en un tema personal antes de que sea un tema técnico.',
    features: ['Las creencias heredadas que los llevan a gastar todo sin darse cuenta', 'Por qué el cerebro sabotea las decisiones financieras y cómo evitarlo', 'Del consumidor pasivo al administrador consciente', 'Actividades de autoconocimiento financiero que la IA no puede resolver por ellos'],
    result: 'Tus alumnos entienden que el problema no es cuánto ganan. Es cómo piensan.'
  }, {
    icon: '📗',
    title: 'TOMO 2 — El Mapa del Tesoro: Presupuesto y Gestión',
    subtitle: 'Darle dirección a cada peso',
    situation: 'Enseñar a organizar el dinero sin que suene a sermón de adulto aburrido.',
    features: ['El método 50/30/20 adaptado a cualquier ingreso', 'El simulador del gasto hormiga: cómo se evapora el dinero sin que lo vean', 'El desafío "Vivir con un salario mínimo" en el aula', 'Metas financieras reales con fecha y número concreto'],
    result: 'Aprenden a darle una dirección a cada peso antes de que desaparezca.'
  }, {
    icon: '📙',
    title: 'TOMO 3 — Bancos, Crédito y el Costo Real de la Deuda',
    subtitle: 'El sistema bancario sin trampas',
    situation: 'Explicar cómo funciona el sistema bancario sin que parezca una conferencia de economía.',
    features: ['Cómo ganan dinero los bancos con tu dinero', 'El costo real de pagar solo el mínimo de la tarjeta', 'Cómo leer un resumen bancario sin perderse', 'Cómo detectar estafas financieras antes de caer'],
    result: 'Entienden el sistema bancario para usarlo a su favor, no en su contra.'
  }, {
    icon: '📕',
    title: 'TOMO 4 — El Mundo de las Inversiones',
    subtitle: 'Invertir desde los 16 años',
    situation: 'Enseñar inversión sin que parezca algo solo para gente con mucho dinero.',
    features: ['Renta fija, acciones, fondos indexados y ETFs explicados con honestidad', 'Criptomonedas: tecnología, realidad y riesgos reales', 'La potencia del interés compuesto empezando a los 16 años', 'Torneo de inversión simulada en el aula'],
    result: 'El ahorro deja de ser un concepto aburrido y se convierte en una decisión de vida.'
  }, {
    icon: '📓',
    title: 'TOMO 5 — Emprendimiento e Ideación',
    subtitle: 'De empleado pasivo a creador de valor',
    situation: 'Que los alumnos dejen de esperar un empleo y empiecen a crear valor.',
    features: ['Cómo identificar un problema real que merece solución', 'El modelo Canvas adaptado para adolescentes', 'Validación de ideas sin gastar un peso', 'Cómo hacer un pitch en tres minutos'],
    result: 'Salen con una idea validada y las herramientas para hacerla real.'
  }, {
    icon: '📔',
    title: 'TOMO 6 — Ciudadanía Financiera, Ética y Protección',
    subtitle: 'El escudo que la escuela nunca les dio',
    situation: 'Cerrar el año con el tomo que protege a tus alumnos de todo lo que el sistema nunca les va a explicar.',
    features: ['Derechos como consumidor financiero y cómo ejercerlos', 'Impuestos, jubilación y seguridad social en términos simples', 'Ética financiera: decisiones que van más allá del bolsillo', 'Seguridad digital: cómo proteger los datos financieros en la era de las apps'],
    result: 'Tus alumnos salen de la escuela con escudo propio.'
  }];
  return <section className="py-6 md:py-8 px-4 bg-brand-cardAlt border-y border-brand-accent/10" data-id="element-160">
      <div className="max-w-5xl mx-auto" data-id="element-161">
        <div className="text-center mb-5" data-id="element-162">
          <h2 className="text-sm md:text-lg font-black text-white mb-2 leading-tight uppercase" data-id="element-163">
            🏆 El sistema más completo de educación financiera para el aula de
            habla hispana
          </h2>
          <p className="text-xl md:text-3xl font-black text-brand-accent neon-glow mb-2 uppercase" data-id="element-164">
            💳 KIT COMPLETO EDUCACIÓN FINANCIERA LISTA
          </p>
          <p className="text-xs md:text-sm text-gray-300 font-bold max-w-2xl mx-auto mb-4" data-id="element-165">
            6 tomos organizados por núcleos temáticos · 120+ secuencias
            didácticas · 4 bonos estratégicos · Todo listo para usar desde hoy.
          </p>

          <div className="bg-brand-card border border-brand-accent/30 rounded-lg p-4 max-w-3xl mx-auto text-left space-y-2 text-sm md:text-base text-gray-300 font-medium leading-relaxed" data-id="element-166">
            <p data-id="element-167">
              <span className="text-red-400 font-bold" data-id="element-168">No es</span> un PDF con
              teoría copiada de Wikipedia.
            </p>
            <p data-id="element-169">
              <span className="text-red-400 font-bold" data-id="element-170">No es</span> una
              colección de actividades sueltas sin hilo conductor.
            </p>
            <p data-id="element-171">
              <span className="text-red-400 font-bold" data-id="element-172">No es</span> material
              pensado para un solo país que después tienes que reescribir
              entero.
            </p>
            <p className="text-white font-black pt-2" data-id="element-173">
              Es un sistema construido por especialistas para entrar al aula con
              confianza, dictar clases que generen participación real y salir
              con la satisfacción de haberles dado a tus alumnos el manual de
              supervivencia económica que nadie más les va a dar.
            </p>
          </div>
        </div>

        <h3 className="text-center text-white font-black mb-5 text-sm md:text-base uppercase bg-brand-accent/10 py-3 rounded-lg border border-brand-accent/40" data-id="element-174">
          📘 LOS 6 TOMOS MAESTROS — 360 PÁGINAS DE VALOR REAL
        </h3>

        <p className="text-center text-gray-400 text-xs md:text-sm font-bold mb-4 italic" data-id="element-175">
          Toca cada tomo para ver el detalle 👇
        </p>

        <div className="space-y-3 mb-6" data-id="element-176">
          {tomos.map((tomo, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-brand-card border-2 rounded-lg overflow-hidden transition-all duration-300 shadow-[0_4px_15px_rgba(0,0,0,0.5)] ${isOpen ? 'border-brand-accent shadow-[0_0_25px_rgba(34,197,94,0.2)]' : 'border-brand-accent/20 hover:border-brand-accent/60'}`} data-id="element-177">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full p-4 md:p-5 flex items-start gap-3 text-left focus:outline-none" aria-expanded={isOpen} data-id="element-178">
                  <span className="text-2xl md:text-3xl leading-none shrink-0" data-id="element-179">
                    {tomo.icon}
                  </span>
                  <div className="flex-grow" data-id="element-180">
                    <h4 className="text-sm md:text-base font-black text-white leading-tight uppercase mb-1" data-id="element-181">
                      {tomo.title}
                    </h4>
                    <p className="text-xs md:text-sm text-brand-accent font-bold" data-id="element-182">
                      {tomo.subtitle}
                    </p>
                  </div>
                  <div className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-brand-accent text-brand-dark' : 'bg-brand-accent/15 text-brand-accent'}`} data-id="element-183">
                    {isOpen ? <ChevronUp className="w-4 h-4" data-id="element-184" /> : <ChevronDown className="w-4 h-4" data-id="element-185" />}
                  </div>
                </button>

                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-186">
                  <div className="px-4 md:px-5 pb-5 pt-1" data-id="element-187">
                    <div className="bg-brand-dark/60 rounded-md p-3 mb-3 border border-white/5" data-id="element-188">
                      <p className="text-[10px] md:text-xs text-brand-accent font-black uppercase mb-1 tracking-wider" data-id="element-189">
                        ¿Qué resuelve en el aula?
                      </p>
                      <p className="text-xs md:text-sm text-gray-300 leading-relaxed font-medium italic" data-id="element-190">
                        {tomo.situation}
                      </p>
                    </div>

                    <div className="space-y-1.5 mb-3" data-id="element-191">
                      {tomo.features.map((f, idx) => <div key={idx} className="flex items-start" data-id="element-192">
                          <CheckCircle2 className="w-3.5 h-3.5 text-brand-accent mr-2 shrink-0 mt-0.5" data-id="element-193" />
                          <span className="text-[11px] md:text-xs text-gray-300 font-bold leading-relaxed" data-id="element-194">
                            {f}
                          </span>
                        </div>)}
                    </div>

                    <div className="border-t border-brand-accent/20 pt-3" data-id="element-195">
                      <p className="text-[10px] md:text-xs text-brand-accent font-black uppercase mb-1 tracking-wider" data-id="element-196">
                        Resultado:
                      </p>
                      <p className="text-xs md:text-sm text-white font-bold leading-relaxed italic" data-id="element-197">
                        {tomo.result}
                      </p>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div onClick={scrollToCompra} className="cursor-pointer text-center text-brand-accent text-xs md:text-sm font-black uppercase tracking-widest hover:neon-glow transition-all" data-id="element-198">
          ⬇ Ver la oferta completa ⬇
        </div>
      </div>
    </section>;
}